export const enCustomerMessages = {
  'customer.auth.loginTitle': 'Sign in to your account',
  'customer.auth.signupTitle': 'Create your account',
  'customer.auth.loginSubtitle': 'Sign in to view your data and complete purchases faster.',
  'customer.auth.loginTrustHint': 'Access orders, profile, support, and privacy from one secure customer area.',
  'customer.auth.signupSubtitle': 'Enter your details. You will complete registration via email.',
  'customer.auth.signupTrustHint':
    'Create your customer profile to manage purchases, data, and support from one area.',
  'customer.auth.signupStep.personal': 'Personal',
  'customer.auth.signupStep.contact': 'Contacts',
  'customer.auth.signupStep.security': 'Security',
  'customer.auth.signupStep.review': 'Confirm',
  'customer.auth.previousStep': 'Back',
  'customer.auth.nextStep': 'Continue',
  'customer.auth.displayName': 'Display name',
  'customer.auth.personalData': 'Personal data',
  'customer.auth.contactData': 'Provide your contact details and address.',
  'customer.auth.securityData': 'After confirmation, you will receive an activation email.',
  'customer.auth.signupPendingSuccess': 'Check your email to complete your registration.',
  'customer.auth.securityTitle': 'Security',
  'customer.auth.securityDescription': 'No password now: you will activate your account by email.',
  'customer.auth.securityHint': 'After confirmation, you will receive an activation link by email.',
  'customer.auth.reviewTitle': 'Review your details',
  'customer.auth.reviewDescription': 'Check your data before creating the account.',
  'customer.auth.reviewEdit': 'Edit',
  'customer.auth.turnstileHelper': 'Security verification required',
  'customer.auth.turnstileRequired': 'Complete the security verification to continue.',
  'customer.auth.signupFailure': 'We could not create your account. Please try again in a few seconds.',
  'customer.auth.signupSuccessTitle': 'Check your email',
  'customer.auth.signupSuccessDescription': 'We sent you a link to complete your registration.',
  'customer.auth.signupSuccessLoginCta': 'Go to login',
  'customer.auth.signupSuccessHomeCta': 'Back to home',
  'customer.auth.stepOf': 'Step {current} of {total}',
  'customer.auth.sidebarTitle': 'You are creating your account',
  'customer.auth.sidebarDescription': 'Complete the steps and activate your profile via email.',
  'customer.auth.firstName': 'First name',
  'customer.auth.lastName': 'Last name',
  'customer.auth.taxCode': 'Tax code',
  'customer.auth.gender': 'Gender',
  'customer.auth.genderPlaceholder': 'Select',
  'customer.auth.gender.option.female': 'Female',
  'customer.auth.gender.option.male': 'Male',
  'customer.auth.gender.option.nonBinary': 'Non-binary',
  'customer.auth.gender.option.preferNot': 'Prefer not to say',
  'customer.auth.phone': 'Phone',
  'customer.auth.phonePrefix': 'Prefix',
  'customer.auth.phonePrefixPlaceholder': 'Select prefix',
  'customer.auth.phonePrefixSearchPlaceholder': 'Search prefix',
  'customer.auth.phonePrefixNoResults': 'No prefixes found',
  'customer.auth.phoneNumber': 'Number',
  'customer.auth.residentialAddress': 'Residential address',
  'customer.auth.addressStreet': 'Street',
  'customer.auth.addressStreetNumber': 'Street number',
  'customer.auth.addressCity': 'City',
  'customer.auth.addressPostalCode': 'Postal code',
  'customer.auth.addressProvince': 'State/Province',
  'customer.auth.addressCountry': 'Country',
  'customer.auth.countrySearchPlaceholder': 'Search country',
  'customer.auth.countryNoResults': 'No countries found',
  'customer.auth.loginIdentifier': 'Email or username',
  'customer.auth.loginIdentifierPlaceholder': 'name@domain.com or username',
  'customer.auth.loginCardTitle': 'Welcome back',
  'customer.auth.loginCardSubtitle': 'Sign in to continue',
  'customer.auth.loginInvalidFeedback': 'Invalid credentials. Check your email and password.',
  'customer.auth.loginSecureAccess': 'Secure access',
  'customer.auth.login.2fa.title': 'Two-step verification',
  'customer.auth.login.2fa.subtitle': 'Enter your OTP code or a recovery code to complete sign-in.',
  'customer.auth.login.2fa.codeLabel': 'Verification code',
  'customer.auth.login.2fa.codePlaceholder': 'OTP code or recovery code',
  'customer.auth.login.2fa.submit': 'Verify and continue',
  'customer.auth.login.2fa.submitting': 'Verifying...',
  'customer.auth.login.2fa.passkey': 'Use passkey',
  'customer.auth.login.2fa.passkeySubmitting': 'Opening passkey...',
  'customer.auth.login.2fa.passkeyHint': 'If you already saved a trusted device, you can use it now.',
  'customer.auth.login.2fa.invalidCode': 'Invalid or expired code.',
  'customer.auth.login.2fa.back': 'Back to login',
  'customer.auth.forgotPassword': 'Forgot password?',
  'customer.auth.forgotPassword.title': 'Recover your password',
  'customer.auth.forgotPassword.subtitle':
    'Enter the email linked to your account and we will send you a reset link.',
  'customer.auth.forgotPassword.submitCta': 'Send reset link',
  'customer.auth.forgotPassword.submittingCta': 'Sending...',
  'customer.auth.forgotPassword.backToLogin': 'Back to login',
  'customer.auth.forgotPassword.successTitle': 'Check your email',
  'customer.auth.forgotPassword.successBody':
    'If the address is registered, you will receive a link to reset your password.',
  'customer.auth.forgotPassword.successHint': 'Also check your spam or promotions folder.',
  'customer.auth.resetPassword.title': 'Reset your password',
  'customer.auth.resetPassword.subtitle': 'Enter a new password for your account',
  'customer.auth.resetPassword.submitCta': 'Update password',
  'customer.auth.resetPassword.submittingCta': 'Updating...',
  'customer.auth.resetPassword.missingToken': 'Invalid or incomplete link',
  'customer.auth.resetPassword.invalidTokenError': 'Invalid or expired token',
  'customer.auth.resetPassword.expiredTitle': 'Link expired',
  'customer.auth.resetPassword.expiredDescription':
    'Your password reset link has expired. Request a new link.',
  'customer.auth.resetPassword.invalidTitle': 'Invalid link',
  'customer.auth.resetPassword.invalidDescription': 'The link you used is invalid or has already been used.',
  'customer.auth.resetPassword.requestNewLinkCta': 'Request new link',
  'customer.auth.resetPassword.submitError': 'We could not update your password. Please try again.',
  'customer.auth.resetPassword.successTitle': 'Password updated',
  'customer.auth.resetPassword.successBody': 'Your password has been updated successfully',
  'customer.auth.resetPassword.backToLogin': 'Back to login',
  'customer.auth.resetPassword.goToLogin': 'Go to login',
  'customer.auth.activate.title': 'Activate your account',
  'customer.auth.activate.subtitle': 'Set a password to complete your registration.',
  'customer.auth.activate.onboarding.title': 'You are almost ready',
  'customer.auth.activate.onboarding.subtitle':
    'Activate your account to start using your customer profile.',
  'customer.auth.activate.onboarding.orders': 'Access to your orders',
  'customer.auth.activate.onboarding.payments': 'Secure payments with Stripe',
  'customer.auth.activate.onboarding.support': 'Dedicated support',
  'customer.auth.activate.formTitle': 'Set your password',
  'customer.auth.activate.formSubtitle': 'Complete your registration',
  'customer.auth.activate.setupTitle': 'Set up your account',
  'customer.auth.activate.setupSubtitle':
    'Set your credentials and choose your security options to complete registration.',
  'customer.auth.activate.check.password': 'Strong password',
  'customer.auth.activate.check.security': 'Account security',
  'customer.auth.activate.check.twoFactor': 'Optional two-step verification',
  'customer.auth.activate.contextNote':
    'You received this email because you created an account on Emporion Store.',
  'customer.auth.activate.cardTitle': 'Complete registration',
  'customer.auth.activate.cardSubtitle':
    'Choose a secure password and configure the main security settings of your account.',
  'customer.auth.activate.loadingTitle': 'Validating your link',
  'customer.auth.activate.loadingBody': 'We are checking whether your activation link is still valid.',
  'customer.auth.activate.section.password': 'Password',
  'customer.auth.activate.requirementsTitle': 'Password requirements',
  'customer.auth.activate.section.security': 'Account security',
  'customer.auth.activate.section.securitySubtitle':
    'After sign-in you can manage 2FA, active sessions, recovery codes, and passkeys from profile settings.',
  'customer.auth.activate.section.twoFactor': 'Two-step verification',
  'customer.auth.activate.section.twoFactorSubtitle':
    'You can add an extra layer of security to your account.',
  'customer.auth.activate.twoFactor.foundationNote':
    'Two-step verification is available in security settings after your first sign-in.',
  'customer.auth.activate.requirements.length': 'At least 8 characters',
  'customer.auth.activate.requirements.letter': 'One uppercase or lowercase letter',
  'customer.auth.activate.requirements.number': 'One number',
  'customer.auth.activate.requirements.match': 'Passwords match',
  'customer.auth.activate.passwordValid': 'Password valid',
  'customer.auth.activate.optionalBadge': 'Optional',
  'customer.auth.activate.twoFactor.openCta': 'Set up 2FA',
  'customer.auth.activate.twoFactor.modal.title': 'Set up two-step verification',
  'customer.auth.activate.twoFactor.modal.subtitle':
    'Complete setup by entering the code generated by your authenticator app.',
  'customer.auth.activate.twoFactor.modal.setupKeyLabel': 'Setup key',
  'customer.auth.activate.twoFactor.modal.codeLabel': 'Verification code',
  'customer.auth.activate.twoFactor.modal.codePlaceholder': 'Enter 6-digit code',
  'customer.auth.activate.twoFactor.modal.cancel': 'Cancel',
  'customer.auth.activate.twoFactor.modal.confirm': 'Enable 2FA',
  'customer.auth.activate.twoFactor.modal.activating': 'Enabling...',
  'customer.auth.activate.twoFactor.modal.backendPending':
    '2FA setup is ready on UI. Backend integration is pending.',
  'customer.auth.activate.completeRegistrationCta': 'Complete registration',
  'customer.auth.activate.profileSettingsNote': 'You can edit these settings later from your profile.',
  'customer.auth.activate.submitCta': 'Activate account and continue',
  'customer.auth.activate.submittingCta': 'Activating...',
  'customer.auth.activate.trustFooter': '🔐 Your data is protected and never shared.',
  'customer.auth.activate.missingToken': 'Invalid or incomplete activation link',
  'customer.auth.activate.invalidTokenError': 'Invalid or expired token',
  'customer.auth.activate.expiredTitle': 'Link expired',
  'customer.auth.activate.expiredDescription':
    'Your activation link has expired. Request a new link to complete your registration.',
  'customer.auth.activate.recovery.expiredSubtitle':
    'Your activation link has expired. You can request a new one.',
  'customer.auth.activate.recovery.invalidSubtitle':
    'The link is no longer valid, but you can easily request a new one.',
  'customer.auth.activate.recovery.leftEyebrow': 'CUSTOMER AREA',
  'customer.auth.activate.recovery.leftTitle': 'Continue registration',
  'customer.auth.activate.recovery.leftSubtitle':
    'The link is no longer valid, but you can request a new one and complete activation securely.',
  'customer.auth.activate.recovery.nextStepsTitle': 'What happens next',
  'customer.auth.activate.recovery.nextStepOne': 'We verify account ownership',
  'customer.auth.activate.recovery.nextStepTwo': 'We send you a new secure link',
  'customer.auth.activate.recovery.nextStepThree': 'You complete registration in seconds',
  'customer.auth.activate.recovery.trustNote':
    "For security reasons we do not show account status. If the address is valid, you'll receive a new link.",
  'customer.auth.activate.recovery.securityPanelTitle': 'Account protection',
  'customer.auth.activate.recovery.securityPanelItemOne': 'Single-use link',
  'customer.auth.activate.recovery.securityPanelItemTwo': 'Automatic expiration',
  'customer.auth.activate.recovery.securityPanelItemThree': 'Required email verification',
  'customer.auth.activate.recovery.helper':
    'To complete registration, request a new activation link.',
  'customer.auth.activate.recovery.cardTitle': 'Request a new link',
  'customer.auth.activate.recovery.cardEyebrow': 'VERIFY ACCOUNT',
  'customer.auth.activate.recovery.cardSubtitle': 'Enter the email used during registration.',
  'customer.auth.activate.recovery.cardSubtitleExpired':
    'Enter your email to receive a new activation link.',
  'customer.auth.activate.recovery.cardSubtitleInvalid':
    'Enter your email and we will send a new link if the account is still eligible for activation.',
  'customer.auth.activate.recovery.submitCta': 'Send activation link',
  'customer.auth.activate.recovery.submittingCta': 'Sending...',
  'customer.auth.activate.recovery.submitHint':
    'The link will be valid for 30 minutes.',
  'customer.auth.activate.recovery.securityNote':
    'We do not reveal whether an account exists or is still activatable.',
  'customer.auth.activate.recovery.successTitle': 'Check your email',
  'customer.auth.activate.recovery.successBody':
    'If the address is valid, we have sent a new activation link.',
  'customer.auth.activate.recovery.successHint': 'The link is valid for 30 minutes.',
  'customer.auth.activate.recovery.successSpamHint':
    'Also check your spam or promotions folder.',
  'customer.auth.activate.recovery.rateLimit': 'Too many attempts. Try again in a few minutes.',
  'customer.auth.activate.recovery.error': 'Temporary error. Please try again.',
  'customer.auth.activate.resendCta': 'Send new link',
  'customer.auth.activate.resendingCta': 'Sending...',
  'customer.auth.activate.resendSuccess': 'A new activation link was sent. Check your email.',
  'customer.auth.activate.resendError': 'We could not send a new link. Please try again.',
  'customer.auth.activate.invalidTitle': 'Invalid link',
  'customer.auth.activate.invalidDescription': 'The link you used is invalid or has already been used.',
  'customer.auth.activate.submitError': 'We could not activate your account. Please try again.',
  'customer.auth.activate.successTitle': 'Account activated',
  'customer.auth.activate.successBody': 'Account activated. Sign in to continue.',
  'customer.auth.activate.backToLogin': 'Back to login',
  'customer.auth.activate.goToLogin': 'Go to login',
  'customer.auth.forgotPasswordUnavailable': 'Password recovery is not available yet.',
  'customer.auth.forgotPasswordHint': 'Feature available soon.',
  'customer.auth.email': 'Email',
  'customer.auth.password': 'Password',
  'customer.auth.password.show': 'Show',
  'customer.auth.password.hide': 'Hide',
  'customer.auth.trust.payments': 'Secure payments with Stripe',
  'customer.auth.trust.paymentsDescription': 'Full protection and encryption on every transaction.',
  'customer.auth.trust.orders': 'Order history always available',
  'customer.auth.trust.ordersDescription': 'Instant access to purchases and payment confirmations.',
  'customer.auth.trust.support': 'Dedicated support',
  'customer.auth.trust.supportDescription': 'Fast support from your customer area with request history.',
  'customer.auth.preview.label': 'Customer area preview',
  'customer.auth.preview.recentOrder': 'Recent order',
  'customer.auth.preview.paymentStatus': 'Payment',
  'customer.auth.preview.shippingStatus': 'Shipping',
  'customer.auth.preview.paid': 'Paid',
  'customer.auth.preview.shipped': 'Shipped',
  'customer.auth.passwordConfirm': 'Confirm password',
  'customer.auth.displayNamePlaceholder': 'John Doe',
  'customer.auth.firstNamePlaceholder': 'John',
  'customer.auth.lastNamePlaceholder': 'Doe',
  'customer.auth.taxCodePlaceholder': 'DOEJHN85M01H501Z',
  'customer.auth.phonePlaceholder': '333 1234567',
  'customer.auth.residentialAddressPlaceholder': 'Main Street 10, Milan',
  'customer.auth.addressStreetPlaceholder': 'Main Street',
  'customer.auth.addressStreetNumberPlaceholder': '10',
  'customer.auth.addressCityPlaceholder': 'Milan',
  'customer.auth.addressPostalCodePlaceholder': '20100',
  'customer.auth.addressProvincePlaceholder': 'MI',
  'customer.auth.addressCountryPlaceholder': 'Italy',
  'customer.auth.country.option.it': 'Italy',
  'customer.auth.country.option.ch': 'Switzerland',
  'customer.auth.country.option.fr': 'France',
  'customer.auth.country.option.de': 'Germany',
  'customer.auth.country.option.es': 'Spain',
  'customer.auth.country.option.pt': 'Portugal',
  'customer.auth.country.option.gb': 'United Kingdom',
  'customer.auth.country.option.us': 'United States',
  'customer.auth.emailPlaceholder': 'name@domain.com',
  'customer.auth.passwordPlaceholder': 'At least 8 characters',
  'customer.auth.passwordConfirmPlaceholder': 'Repeat your password',
  'customer.auth.passwordStrength.title': 'Password strength',
  'customer.auth.passwordStrength.weak': 'Weak',
  'customer.auth.passwordStrength.medium': 'Medium',
  'customer.auth.passwordStrength.strong': 'Strong',
  'customer.auth.loginCta': 'Sign in',
  'customer.auth.signupCta': 'Create account',
  'customer.auth.hasAccount': 'Already have an account?',
  'customer.auth.missingAccount': 'Do not have an account yet?',
  'customer.auth.toLogin': 'Go to login',
  'customer.auth.toSignup': 'Sign up',
  'customer.auth.requiredLegend': '* Required field',
  'customer.auth.validation.requiredField': 'Required field.',
  'customer.auth.validation.personalIncomplete': 'Complete first name, last name, tax code and email.',
  'customer.auth.validation.emailInvalid': 'Invalid email format.',
  'customer.auth.validation.taxCodeInvalid': 'Invalid tax code (11-16 alphanumeric characters).',
  'customer.auth.validation.genderRequired': 'Please select gender.',
  'customer.auth.validation.passwordMismatch': 'Password confirmation does not match.',
  'customer.auth.validation.passwordWeak': 'Password is too weak: use at least 8 characters and stronger combinations.',
  'customer.auth.validation.phoneInvalid': 'Invalid phone number.',
  'customer.auth.validation.postalCodeInvalid': 'Invalid postal code.',
  'customer.auth.validation.addressIncomplete': 'Please complete every residential address field.',
  'customer.accessRequired.title': 'Access required',
  'customer.accessRequired.description': 'You need to sign in as customer to view this section.',
  'customer.accessRequired.contextTitle': 'Sign in to continue',
  'customer.accessRequired.contextDescription':
    'To view orders, invoices, and shipping status, sign in to your account.',
  'customer.accessRequired.cardDescription':
    'Enter your customer area to continue your operations securely.',
  'customer.accessRequired.trust.orders': 'Order history',
  'customer.accessRequired.trust.tracking': 'Shipping tracking',
  'customer.accessRequired.trust.support': 'Dedicated support',
  'customer.initializing': 'Loading customer area...',

  'customer.dashboard.accountData': 'Account data',
  'customer.dashboard.profileData': 'Personal data',
  'customer.dashboard.addressesTitle': 'Addresses',
  'customer.dashboard.addressesDescription': 'Manage billing and shipping addresses.',
  'customer.dashboard.nextSteps': 'Next steps',
  'customer.dashboard.username': 'Username',
  'customer.dashboard.firstName': 'First name',
  'customer.dashboard.lastName': 'Last name',
  'customer.dashboard.taxCode': 'Tax code',
  'customer.dashboard.phone': 'Phone',
  'customer.dashboard.residentialAddress': 'Residential address',
  'customer.dashboard.billingAddress': 'Billing address',
  'customer.dashboard.shippingAddress': 'Shipping address',
  'customer.dashboard.lastLogin': 'Last login',
  'customer.dashboard.device': 'Device',
  'customer.dashboard.deviceUnavailable': 'Not available',
  'customer.dashboard.toOrders': 'Go to order history',
  'customer.dashboard.toSupport': 'Open support request',
  'customer.dashboard.toPrivacy': 'Manage privacy & data',
  'customer.dashboard.saveAddresses': 'Save addresses',
  'customer.dashboard.savingAddresses': 'Saving...',
  'customer.dashboard.addressesSaved': 'Addresses updated successfully.',
  'customer.dashboard.addressesSaveError': 'Unable to save addresses.',

  'customer.orders.title': 'Your orders',
  'customer.orders.subtitle': 'Order history linked to your account',
  'customer.orders.continueShopping': 'Continue shopping',
  'customer.orders.searchPlaceholder': 'Search by order number or product',
  'customer.orders.loading': 'Loading orders...',
  'customer.orders.syncInProgress': 'Updating…',
  'customer.orders.emptyTitle': 'You have not placed any orders yet',
  'customer.orders.emptyDescription': 'After checkout, your order history will appear here.',
  'customer.orders.emptyCta': 'Discover products',
  'customer.orders.noMatchTitle': 'No orders match the applied filters',
  'customer.orders.noMatchDescription': 'Remove or adjust filters to view more orders.',
  'customer.orders.order': 'Order',
  'customer.orders.createdAt': 'Created on {date}',
  'customer.orders.items': 'Items',
  'customer.orders.status': 'Status',
  'customer.orders.total': 'Total',
  'customer.orders.detailCta': 'View order details',
  'customer.orders.rebuyCta': 'Buy again',
  'customer.orders.supportCta': 'Request support',
  'customer.orders.productFallback': 'Product unavailable',
  'customer.orders.productsLabel': 'products',
  'customer.orders.paymentMethod': 'Payment method',
  'customer.orders.paymentMethodFallback': 'Payment handled by Stripe',
  'customer.orders.sort.label': 'Sort',
  'customer.orders.sort.recent': 'Most recent',
  'customer.orders.sort.oldest': 'Oldest first',
  'customer.orders.sort.priceDesc': 'Price high -> low',
  'customer.orders.sort.priceAsc': 'Price low -> high',
  'customer.orders.resultsCount': '{count} orders',
  'customer.orders.pagination.perPage': 'Rows',
  'customer.orders.pagination.summary': '{from}-{to} of {total}',
  'customer.orders.pagination.previous': 'Previous',
  'customer.orders.pagination.next': 'Next',

  'customer.orderDetail.title': 'Order details',
  'customer.orderDetail.idLabel': 'Order ID: {id}',
  'customer.orderDetail.backToOrders': 'Back to orders',
  'customer.orderDetail.loading': 'Loading order details...',
  'customer.orderDetail.toOrders': 'Go to order list',
  'customer.orderDetail.createdAt': 'Created on',
  'customer.orderDetail.updatedAt': 'Updated on',
  'customer.orderDetail.paidAt': 'Paid on',
  'customer.orderDetail.cancelledAt': 'Cancelled on',
  'customer.orderDetail.subtotal': 'Subtotal',
  'customer.orderDetail.paymentMethod': 'Payment method',
  'customer.orderDetail.paymentMethodFallback': 'Payment handled by Stripe',
  'customer.orderDetail.itemsList': 'Order lines',
  'customer.orderDetail.itemsEmpty': 'No items found.',
  'customer.orderDetail.invoices': 'Invoices',
  'customer.orderDetail.invoicesSubtitle': 'Tax documents available for this order.',
  'customer.orderDetail.invoicesSubtitleSingle': '1 tax document available',
  'customer.orderDetail.invoicesSubtitleMany': '{count} tax documents available',
  'customer.orderDetail.invoicesLoading': 'Loading invoices...',
  'customer.orderDetail.invoicesEmpty': 'No invoices are currently available for this order.',
  'customer.orderDetail.invoicesEmptyHint': 'Tax documents will appear here once they are generated.',
  'customer.orderDetail.invoiceDate': 'Invoice dated {invoiceDate}. Available since {uploadedAt}',
  'customer.orderDetail.invoiceIssuedAt': 'Invoice dated {date}',
  'customer.orderDetail.invoiceAvailableAt': 'Available since {date}',
  'customer.orderDetail.openInvoice': 'Download PDF',
  'customer.orderDetail.openingInvoice': 'Downloading...',
  'customer.orderDetail.openInvoiceHint': 'Open',
  'customer.orderDetail.openingInvoiceHint': 'Opening...',
  'customer.orderDetail.openInvoiceError': 'Cannot open invoice',

  'customer.support.title': 'Support',
  'customer.support.subtitle': 'Open a request and monitor your support tickets.',
  'customer.support.newRequest': 'New request',
  'customer.support.history': 'Requests history',
  'customer.support.subject': 'Subject',
  'customer.support.subjectPlaceholder': 'Ex. Problem with order',
  'customer.support.orderId': 'Order ID (optional)',
  'customer.support.message': 'Message',
  'customer.support.messagePlaceholder': 'Describe the issue in detail...',
  'customer.support.submit': 'Send request',
  'customer.support.submitting': 'Sending...',
  'customer.support.loading': 'Loading support requests...',
  'customer.support.empty': 'No support requests found.',
  'customer.support.openedAt': 'Opened: {date}',
  'customer.support.closedAt': 'Closed: {date}',
  'customer.support.order': 'Order: {orderNumber}',
  'customer.support.formSubtitle': 'Describe your issue and optionally link an order.',
  'customer.support.historySubtitle': 'Track updates for open and resolved requests.',
  'customer.support.orderIdPlaceholder': 'E.g. ord_123456',
  'customer.support.previewFallback': 'No additional details provided.',
  'customer.support.categoryLabel': 'Category',
  'customer.support.category.general': 'General',
  'customer.support.category.order': 'Order',
  'customer.support.category.shipping': 'Shipping',
  'customer.support.category.payment': 'Payment',
  'customer.support.category.privacy': 'Privacy',
  'customer.support.priorityLabel': 'Priority',
  'customer.support.priority.normal': 'Normal',
  'customer.support.priority.high': 'High',
  'customer.support.priority.urgent': 'Urgent',
  'customer.support.contextLinkedOrder': 'Request linked to order {orderRef}',
  'customer.support.contextOrderStatus': 'Order status: {status}',
  'customer.support.contextMainProduct': 'Main product: {product}',
  'customer.support.kpi.open': 'Open tickets',
  'customer.support.kpi.inProgress': 'In progress',
  'customer.support.kpi.resolved': 'Resolved',
  'customer.support.openTicketDetail': 'Open ticket detail',
  'customer.support.detailTitle': 'Ticket detail',
  'customer.support.detailSubtitle': 'Ticket {ticketId}',
  'customer.support.backToList': 'Back to list',
  'customer.support.detailNotFoundTitle': 'Ticket not found',
  'customer.support.detailNotFoundDescription':
    'The requested ticket is unavailable or does not belong to this account.',
  'customer.support.detail.ticketId': 'Ticket ID',
  'customer.support.detail.status': 'Status',
  'customer.support.detail.updatedAt': 'Last update',
  'customer.support.detail.openedAt': 'Opened on {date}',
  'customer.support.detail.customerMessage': 'Customer message',
  'customer.support.detail.supportReply': 'Support reply',
  'customer.support.detail.noReplyYet': 'No support reply yet.',

  'customer.nav.overview': 'Overview',
  'customer.nav.overviewDescription': 'Account status, KPIs and quick actions',
  'customer.nav.orders': 'Orders',
  'customer.nav.ordersDescription': 'Order history and status tracking',
  'customer.nav.support': 'Support',
  'customer.nav.supportDescription': 'Support tickets and updates',
  'customer.nav.privacy': 'Privacy & data',
  'customer.nav.privacyDescription': 'Consents, export and account controls',
  'customer.nav.profile': 'Profile & security',
  'customer.nav.profileDescription': 'Personal data, access, and account security',
  'customer.nav.addresses': 'Addresses',
  'customer.nav.addressesDescription': 'Residential, billing and shipping',
  'customer.nav.preferences': 'Billing & payments',
  'customer.nav.preferencesDescription': 'Billing details and payment security',

  'customer.dashboard.heroTitle': 'Welcome back, {name}',
  'customer.dashboard.heroSubtitle':
    'Manage account, orders, support and privacy from one customer workspace.',
  'customer.dashboard.overview.title': 'Account overview',
  'customer.dashboard.overview.subtitle': 'Operational status and key profile information.',
  'customer.dashboard.kpi.totalOrders': 'Total orders',
  'customer.dashboard.kpi.activeOrders': 'Active orders',
  'customer.dashboard.kpi.openTickets': 'Open tickets',
  'customer.dashboard.kpi.savedAddresses': 'Saved addresses',
  'customer.dashboard.kpi.exportState': 'Data export status',
  'customer.dashboard.kpi.customerCode': 'Customer code',
  'customer.dashboard.kpi.accountStatus': 'Account status',
  'customer.dashboard.kpi.noData': 'N/A',
  'customer.dashboard.manageProfile': 'Manage profile',
  'customer.dashboard.quickActions.title': 'Quick actions',
  'customer.dashboard.quickActions.subtitle': 'Fast access to the most common tasks.',
  'customer.dashboard.quickActions.ordersTitle': 'View orders',
  'customer.dashboard.quickActions.ordersDescription': 'Check order status and details.',
  'customer.dashboard.quickActions.supportTitle': 'Contact support',
  'customer.dashboard.quickActions.supportDescription': 'Open a request and track updates.',
  'customer.dashboard.quickActions.privacyTitle': 'Manage privacy',
  'customer.dashboard.quickActions.privacyDescription': 'Update consents and GDPR requests.',
  'customer.dashboard.quickActions.profileTitle': 'Update profile',
  'customer.dashboard.quickActions.profileDescription': 'Keep personal and contact data updated.',
  'customer.dashboard.quickActions.addressesTitle': 'Update addresses',
  'customer.dashboard.quickActions.addressesDescription':
    'Edit residential, billing and shipping addresses.',
  'customer.dashboard.activity.title': 'Recent activity',
  'customer.dashboard.activity.subtitle': 'Latest relevant events for your account.',
  'customer.dashboard.activity.empty': 'No recent activity available.',
  'customer.dashboard.activity.orderCreated': 'Order created',
  'customer.dashboard.activity.orderStatus': 'Order status updated',
  'customer.dashboard.activity.supportCreated': 'New support ticket',
  'customer.dashboard.activity.supportFallback': 'Ticket update',
  'customer.dashboard.activity.privacyRequest': 'Privacy request',
  'customer.dashboard.activity.privacyStatus': 'Privacy request status',
  'customer.dashboard.activity.lastLogin': 'Last sign in',
  'customer.dashboard.essentialData.title': 'Essential data',
  'customer.dashboard.essentialData.subtitle': 'Main information for your customer account.',

  'customer.orders.filters.title': 'Order filters',
  'customer.orders.filters.subtitle': 'Quickly find orders by status or number.',
  'customer.orders.filters.searchLabel': 'Search order',
  'customer.orders.filters.searchPlaceholder': 'Order number or reference',
  'customer.orders.filters.open': 'Filters',
  'customer.orders.filters.close': 'Hide filters',
  'customer.orders.filters.date.label': 'Date',
  'customer.orders.filters.date.all': 'All dates',
  'customer.orders.filters.date.last30': 'Last 30 days',
  'customer.orders.filters.date.last3Months': 'Last 3 months',
  'customer.orders.filters.date.lastYear': 'Last year',
  'customer.orders.filters.date.custom': 'Custom range',
  'customer.orders.filters.date.from': 'From',
  'customer.orders.filters.date.to': 'To',
  'customer.orders.filters.status.label': 'Order status',
  'customer.orders.filters.price.label': 'Price',
  'customer.orders.filters.price.min': 'Min',
  'customer.orders.filters.price.max': 'Max',
  'customer.orders.filters.price.minPlaceholder': 'E.g. 50',
  'customer.orders.filters.price.maxPlaceholder': 'E.g. 200',
  'customer.orders.filters.reset': 'Reset filters',
  'customer.orders.filters.statusLabel': 'Status',
  'customer.orders.filters.statusAll': 'All statuses',
  'customer.orders.kpi.total': 'Total orders',
  'customer.orders.kpi.totalMeta': 'Full account history',
  'customer.orders.kpi.processing': 'Processing',
  'customer.orders.kpi.processingMeta': 'Orders still in progress',
  'customer.orders.kpi.latest': 'Latest order',
  'customer.orders.kpi.noData': 'No orders',

  'customer.profile.title': 'Account profile',
  'customer.profile.subtitle': 'Update personal details, contacts and registry information.',
  'customer.profile.formTitle': 'Profile details',
  'customer.profile.formSubtitle': 'Changes are applied to your customer account.',
  'customer.profile.save': 'Save profile',
  'customer.profile.saving': 'Saving...',
  'customer.profile.saved': 'Profile updated successfully.',
  'customer.profile.saveError': 'Unable to update profile.',
  'customer.profile.accountInfoTitle': 'Account information',
  'customer.profile.accountId': 'Account ID',
  'customer.profile.passkeys.title': 'Trusted devices',
  'customer.profile.passkeys.subtitle': 'Add a device you trust to confirm sign-in quickly.',
  'customer.profile.passkeys.add': 'Add passkey',
  'customer.profile.passkeys.loading': 'Please wait...',
  'customer.profile.passkeys.empty': 'No trusted devices saved yet.',
  'customer.profile.passkeys.createdAt': 'Added on {date}',
  'customer.profile.passkeys.remove': 'Remove',
  'customer.profile.passkeys.removing': 'Removing...',
  'customer.profile.passkeys.requiresTwoFactor': 'Turn on 2FA before adding a passkey.',
  'customer.profile.passkeys.notSupported': 'This browser cannot add a passkey.',
  'customer.profile.passkeys.deviceDefault': 'Device {count}',
  'customer.profile.passkeys.error.load': 'Unable to load trusted devices.',
  'customer.profile.passkeys.error.add': 'Unable to add this device.',
  'customer.profile.passkeys.error.remove': 'Unable to remove this device.',
  'customer.profile.passkeys.success.added': 'Device added successfully.',
  'customer.profile.passkeys.success.removed': 'Device removed successfully.',

  'customer.addresses.title': 'Addresses',
  'customer.addresses.subtitle': 'Manage residential, billing and shipping addresses.',
  'customer.addresses.formTitle': 'Address book',
  'customer.addresses.formSubtitle': 'Keep addresses used for your orders up to date.',
  'customer.addresses.save': 'Save addresses',
  'customer.addresses.saving': 'Saving...',
  'customer.addresses.saved': 'Addresses updated successfully.',
  'customer.addresses.saveError': 'Unable to save addresses.',

  'customer.preferences.title': 'Billing & payments',
  'customer.preferences.subtitle':
    'Manage the details used for invoicing and view payment information.',
  'customer.preferences.banner.prefix': 'Secure payments via',
  'customer.preferences.banner.brand': 'Stripe',
  'customer.preferences.banner.suffix': '- your card details are never stored',
  'customer.preferences.banner.tooltip':
    'Stripe is a secure payment platform used by millions of businesses worldwide.',
  'customer.preferences.billing.title': 'Billing details',
  'customer.preferences.billing.subtitle':
    'Enter the details used for invoicing your orders.',
  'customer.preferences.billing.firstName': 'First name',
  'customer.preferences.billing.lastName': 'Last name',
  'customer.preferences.billing.taxCode': 'Tax code',
  'customer.preferences.billing.phone': 'Phone (optional)',
  'customer.preferences.billing.email': 'Billing email (optional)',
  'customer.preferences.billing.useForNextOrders':
    'Use these details for upcoming orders',
  'customer.preferences.billing.autoApplyHint':
    'Used automatically in upcoming orders',
  'customer.preferences.billing.requiredFieldsError':
    'Fill in first name, last name and tax code to continue.',
  'customer.preferences.billing.taxCodeInvalid': 'Enter a valid tax code (16 characters).',
  'customer.preferences.billing.emailInvalid': 'Enter a valid email address.',
  'customer.preferences.billing.save': 'Save details',
  'customer.preferences.billing.saving': 'Saving...',
  'customer.preferences.billing.saved': 'Billing details updated.',
  'customer.preferences.billing.toastSaved': 'Details updated successfully',
  'customer.preferences.billing.saveError': 'Unable to save billing details.',
  'customer.preferences.address.title': 'Primary address',
  'customer.preferences.address.subtitle':
    'Main address used for orders and billing.',
  'customer.preferences.address.summaryLabel': 'Main address',
  'customer.preferences.address.nameFallback': 'Address owner',
  'customer.preferences.address.usageTitle': 'Used for:',
  'customer.preferences.address.usageShipping': 'shipping',
  'customer.preferences.address.usageBilling': 'billing',
  'customer.preferences.address.manage': 'Manage addresses',
  'customer.preferences.address.emptyTitle': 'No associated address',
  'customer.preferences.address.emptyDescription':
    'Add an address to complete upcoming orders faster.',
  'customer.preferences.address.emptyCta': 'Go to addresses',
  'customer.preferences.security.title': 'Secure payments',
  'customer.preferences.security.subtitle': 'Useful information about payment security.',
  'customer.preferences.security.lead':
    'Payments are securely handled through Stripe. We do not store your card details.',
  'customer.preferences.security.point1': 'Payments protected by Stripe',
  'customer.preferences.security.point2': 'No card data stored on this site',
  'customer.preferences.security.point3': 'Secure checkout',
  'customer.preferences.lastPayment.title': 'Latest payment',
  'customer.preferences.lastPayment.subtitle': 'Details of the latest recorded payment.',
  'customer.preferences.lastPayment.amount': 'Amount',
  'customer.preferences.lastPayment.date': 'Date',
  'customer.preferences.lastPayment.status': 'Status',
  'customer.preferences.lastPayment.order': 'Order',

  'customer.privacy.title': 'Privacy & data',
  'customer.privacy.subtitle':
    'Manage personal data, communication preferences and GDPR requests from one place.',
  'customer.privacy.loading': 'Loading privacy section...',
  'customer.privacy.unavailable': 'Privacy section is currently unavailable.',
  'customer.privacy.refresh': 'Refresh',
  'customer.privacy.refreshing': 'Refreshing...',
  'customer.privacy.accountStatusLabel': 'Account status',
  'customer.privacy.exportStatus': 'Export status',
  'customer.privacy.lastUpdated': 'Last updated',
  'customer.privacy.quickLinksTitle': 'Quick privacy actions',
  'customer.privacy.quickLinksSubtitle': 'Handle key privacy operations in a few clicks.',
  'customer.privacy.quickAction.exportTitle': 'Request export',
  'customer.privacy.quickAction.exportDescription': 'Prepare a file with your account data.',
  'customer.privacy.quickAction.profileTitle': 'Update personal data',
  'customer.privacy.quickAction.profileDescription': 'Edit profile and contact references.',
  'customer.privacy.quickAction.profileCta': 'Open profile',
  'customer.privacy.quickAction.preferencesTitle': 'Update preferences',
  'customer.privacy.quickAction.preferencesDescription': 'Review language and communications.',
  'customer.privacy.quickAction.preferencesCta': 'Open preferences',
  'customer.privacy.quickAction.deleteTitle': 'Delete account',
  'customer.privacy.quickAction.deleteDescription': 'Start secure account deletion flow.',
  'customer.privacy.quickAction.deleteCta': 'Go to deletion',
  'customer.privacy.requestExport': 'Request export',
  'customer.privacy.accountStatus.deletionRequested': 'Deletion requested',
  'customer.privacy.accountStatus.deletionPending': 'Deletion in progress',
  'customer.privacy.unavailableTitle': 'Privacy section unavailable',
  'customer.privacy.unavailableDescription':
    'We could not load privacy data for this account. Try again in a few moments.',
  'customer.privacy.accountStatus.active': 'Active',
  'customer.privacy.accountStatus.pendingDeletion': 'Pending deletion',
  'customer.privacy.accountStatus.anonymized': 'Anonymized',
  'customer.privacy.accountStatus.deleted': 'Deleted',
  'customer.privacy.overview.title': 'Your data',
  'customer.privacy.overview.description':
    'Summary of account privacy status and latest profile updates.',
  'customer.privacy.overview.accountStatus': 'Account status',
  'customer.privacy.overview.privacyUpdatedAt': 'Last privacy update',
  'customer.privacy.overview.dataOwner': 'Data owner',
  'customer.privacy.export.title': 'Download my data',
  'customer.privacy.export.description':
    'Request a complete export of account, profile, orders, invoices, support requests and privacy preferences.',
  'customer.privacy.export.state': 'Export status',
  'customer.privacy.export.expiresAt': 'Available until',
  'customer.privacy.export.request': 'Request export',
  'customer.privacy.export.requesting': 'Requesting...',
  'customer.privacy.export.download': 'Download export',
  'customer.privacy.export.downloading': 'Downloading...',
  'customer.privacy.exportState.none': 'No request',
  'customer.privacy.exportState.pending': 'Pending',
  'customer.privacy.exportState.processing': 'In preparation',
  'customer.privacy.exportState.ready': 'Ready',
  'customer.privacy.exportState.expired': 'Expired',
  'customer.privacy.consents.title': 'Consents and preferences',
  'customer.privacy.consents.description':
    'Update optional marketing and promotional communications preferences.',
  'customer.privacy.consents.mandatory': 'Privacy policy',
  'customer.privacy.consents.accepted': 'Accepted',
  'customer.privacy.consents.notAccepted': 'Not accepted',
  'customer.privacy.consents.acceptedAt': 'Accepted on',
  'customer.privacy.consents.marketingEmail': 'I agree to receive marketing emails.',
  'customer.privacy.consents.promotionalNotifications':
    'I agree to receive promotional product updates.',
  'customer.privacy.consents.save': 'Save preferences',
  'customer.privacy.consents.saving': 'Saving...',
  'customer.privacy.profile.title': 'Personal data',
  'customer.privacy.profile.description':
    'Review and update your personal details, contact references and addresses.',
  'customer.privacy.profile.save': 'Save personal data',
  'customer.privacy.profile.saving': 'Saving data...',
  'customer.privacy.delete.title': 'Delete account',
  'customer.privacy.delete.description':
    'Start the deletion flow for your account with mandatory password confirmation.',
  'customer.privacy.delete.warningTitle': 'Important',
  'customer.privacy.delete.warningBody':
    'Account deletion is irreversible. Some order-related data may be retained for legal and fiscal obligations.',
  'customer.privacy.delete.action': 'Request account deletion',
  'customer.privacy.delete.modalTitle': 'Confirm account deletion',
  'customer.privacy.delete.modalDescription':
    'To continue, enter your current password and confirm that you understand the consequences.',
  'customer.privacy.delete.passwordLabel': 'Current password',
  'customer.privacy.delete.confirmLabel':
    'I confirm that I want to delete my account and understand this action is irreversible.',
  'customer.privacy.delete.cancel': 'Cancel',
  'customer.privacy.delete.submit': 'Confirm deletion',
  'customer.privacy.delete.submitting': 'Processing...',
  'customer.privacy.activity.title': 'Recent privacy activity',
  'customer.privacy.activity.description':
    'Timeline of GDPR requests and privacy actions related to your account.',
  'customer.privacy.activity.empty': 'No privacy activities recorded yet.',
  'customer.privacy.activity.createdAt': 'Created on {date}',
  'customer.privacy.activity.typeExport': 'Data export request',
  'customer.privacy.activity.typeDeletion': 'Account deletion request',

  'checkout.title': 'Checkout',
  'checkout.subtitle': 'Complete shipment details before secure payment.',
  'checkout.loadingSession': 'Preparing checkout session...',
  'checkout.empty.title': 'Your cart is empty',
  'checkout.empty.description': 'Add at least one product before starting checkout.',
  'checkout.empty.ctaCart': 'Back to cart',
  'checkout.empty.ctaCatalog': 'Go to catalog',
  'checkout.progress.ariaLabel': 'Checkout progress',
  'checkout.progress.mobileLabel': 'Current step',
  'checkout.progress.mobileCounter': '{current} / {total}',
  'checkout.step.cart': 'Cart',
  'checkout.step.shipping': 'Shipping',
  'checkout.step.billing': 'Billing',
  'checkout.step.method': 'Method',
  'checkout.step.review': 'Review',
  'checkout.step.payment': 'Payment',
  'checkout.cta.continueCheckout': 'Continue checkout',
  'checkout.cta.saveAndContinue': 'Save and continue',
  'checkout.cta.continue': 'Continue',
  'checkout.cta.saveMethod': 'Save method',
  'checkout.cta.proceedToPayment': 'Proceed to payment',
  'checkout.cta.confirmBankTransferOrder': 'Confirm order with bank transfer',
  'checkout.cta.edit': 'Edit',
  'checkout.cta.back': 'Back',
  'checkout.cta.cancel': 'Cancel',
  'checkout.cta.retry': 'Retry',
  'checkout.cta.backToCart': 'Back to cart',
  'checkout.cta.dismiss': 'Dismiss',
  'checkout.cta.goToOrders': 'Go to orders',
  'checkout.field.firstName': 'First name',
  'checkout.field.lastName': 'Last name',
  'checkout.field.company': 'Company',
  'checkout.field.line1': 'Address line 1',
  'checkout.field.line2': 'Address line 2',
  'checkout.field.city': 'City',
  'checkout.field.postalCode': 'Postal code',
  'checkout.field.region': 'Region',
  'checkout.field.country': 'Country code (ISO2)',
  'checkout.field.phone': 'Phone',
  'checkout.validation.required': '{field} is required.',
  'checkout.validation.postalCodeInvalid': 'Invalid postal code.',
  'checkout.validation.countryInvalid': 'Country must use 2-letter ISO code (for example IT).',
  'checkout.validation.phoneInvalid': 'Invalid phone number.',
  'checkout.cartReview.title': 'Cart review',
  'checkout.cartReview.description': 'Verify products before entering shipping details.',
  'checkout.shippingAddress.title': 'Shipping address',
  'checkout.shippingAddress.description': 'Enter delivery destination details.',
  'checkout.billingAddress.title': 'Billing address',
  'checkout.billingAddress.description': 'Choose if billing matches shipping.',
  'checkout.billing.title': 'Billing options',
  'checkout.billing.sameAsShipping': 'Use this address for billing as well',
  'checkout.billing.useShippingAddress': 'Use shipping address',
  'checkout.billing.useDifferentAddress': 'Use a different billing address',
  'checkout.billing.previewTitle': 'Billing preview',
  'checkout.addressBook.title': 'Saved addresses',
  'checkout.addressBook.addNew': 'Add new address',
  'checkout.addressBook.defaultBadge': 'Default',
  'checkout.addressBook.selectedBadge': 'Selected',
  'checkout.addressBook.panelAddTitle': 'New address',
  'checkout.addressBook.panelEditTitle': 'Edit address',
  'checkout.addressBook.saveAddress': 'Save address',
  'checkout.addressBook.panelMissingFields': 'Fill required fields before saving this address.',
  'checkout.shippingMethod.title': 'Shipping method',
  'checkout.shippingMethod.description': 'Choose delivery speed.',
  'checkout.shippingMethod.standard.label': 'Standard shipping',
  'checkout.shippingMethod.standard.description': 'Regular delivery',
  'checkout.shippingMethod.standard.estimate': 'Estimated delivery: 3-5 business days',
  'checkout.shippingMethod.express.label': 'Express shipping',
  'checkout.shippingMethod.express.description': 'Priority delivery',
  'checkout.shippingMethod.express.estimate': 'Estimated delivery: 1-2 business days',
  'checkout.shippingMethod.recommended': 'Recommended',
  'checkout.review.title': 'Review checkout',
  'checkout.review.description': 'Review addresses and totals before payment.',
  'checkout.review.products': 'Products',
  'checkout.review.shippingAddress': 'Shipping',
  'checkout.review.billingAddress': 'Billing',
  'checkout.review.shippingMethod': 'Method',
  'checkout.review.paymentMethod': 'Payment',
  'checkout.review.totals': 'Totals',
  'checkout.review.subtotal': 'Subtotal',
  'checkout.review.shipping': 'Shipping',
  'checkout.review.tax': 'Tax',
  'checkout.review.discount': 'Discount',
  'checkout.review.total': 'Total',
  'checkout.review.notSelected': 'Not selected',
  'checkout.summary.title': 'Order summary',
  'checkout.summary.show': 'Show',
  'checkout.summary.hide': 'Hide',
  'checkout.summary.securityTitle': 'Secure payment',
  'checkout.summary.securityBody': 'Payments are processed securely by Stripe. Card data never touches this shop.',
  'checkout.summary.statusPending': 'Payment session pending confirmation.',
  'checkout.summary.statusExpired': 'Checkout session expired. Restart from cart.',
  'checkout.summary.statusCancelled': 'Checkout session cancelled.',
  'checkout.redirect.title': 'Redirecting to secure payment',
  'checkout.redirect.description': 'Please wait while we open Stripe checkout.',
  'checkout.error.sessionCreationFailed': 'Unable to create a checkout session.',
  'checkout.error.sessionLoadFailed': 'Unable to load checkout session.',
  'checkout.error.sessionExpired': 'Checkout session has expired. Start again from cart.',
  'checkout.error.emptyCart': 'Your cart is empty. Add products before checkout.',
  'checkout.error.invalidStep': 'This step is not available yet. Complete previous steps first.',
  'checkout.error.backendValidation': 'Some checkout data is invalid. Check highlighted fields.',
  'checkout.error.confirmPaymentFailed': 'Unable to start payment. Please retry.',
  'checkout.error.generic': 'Unexpected checkout error.',
  'checkout.completed.title': 'Checkout completed',
  'checkout.completed.description': 'Payment is already confirmed. Open your orders from dashboard.',
  'checkout.completed.bankTransferDescription':
    'Order received. Payment remains pending until the bank transfer is received and confirmed.',
  'checkout.completed.bankTransferTitle': 'Bank transfer instructions',
  'checkout.completed.beneficiary': 'Beneficiary',
  'checkout.completed.iban': 'IBAN',
  'checkout.completed.bank': 'Bank',
  'checkout.completed.amount': 'Amount',
  'checkout.completed.reference': 'Payment reference',
  'checkout.payment.provider.bankTransfer': 'Bank transfer',
  'checkout.payment.provider.bankTransferDescription': 'Manual payment confirmation after incoming transfer.',
  'checkout.payment.provider.stripe': 'Card (Stripe)',
  'checkout.payment.provider.stripeDescription': 'Secure online payment with Stripe Checkout redirect.',

  'customer.placeholder.title': 'Section in progress',
  'customer.placeholder.description': 'Page /dashboard/{nestedPath} will be completed in upcoming issues.',
  'customer.placeholder.back': 'Back to dashboard',
} as const
